/**
 * @desc 保存网站公告
 */
import { NoticeEntity, NoticeForm } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateNoticeParameter = NoticeForm

const method = 'POST'
const url = '/content/operation/notice'

export const createNoticeApi = (
  data?: CreateNoticeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<NoticeEntity>({
    method,
    url,
    data,
    ...config
  })
}

createNoticeApi.method = method
createNoticeApi.url = url
